// Hot fix for JWT errors blowing up app due to 400 errors from API
export function handleJwtError(err) {
  if (!err) return;
  if (!err.message) return;
  if (!err.message.match(/jwt/i)) return;
  if (document.location.href.match(/sessionExpired/)) return;
  localStorage.removeItem('jwt');
  document.location = '/?sessionExpired=true';
}
